import React, { Component } from 'react';
import { connect } from "react-redux";

const RouteHeader = ({ routeId, namespace, routeName }) => {
	return (
		<React.Fragment>
		{ routeId ?
			<h1>Editing route: {namespace + '/' + routeName}</h1> :
			<h1>Adding new route</h1> }
		</React.Fragment>
	)
};

export default connect( state => ({
	routeId: state.routeId,
	namespace: state.settings.namespace,
	routeName: state.settings.routeName
}))(RouteHeader);